var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46875 8L10.8438 11.375C11.0312 11.5625 11.0312 11.9062 10.8438 12.0938L10.0625 12.875C9.875 13.0625 9.53125 13.0625 9.34375 12.875L6 9.5L2.625 12.875C2.4375 13.0625 2.09375 13.0625 1.90625 12.875L1.125 12.0938C0.9375 11.9062 0.9375 11.5625 1.125 11.375L4.5 8L1.125 4.65625C0.9375 4.46875 0.9375 4.125 1.125 3.9375L1.90625 3.15625C2.09375 2.96875 2.4375 2.96875 2.625 3.15625L6 6.53125L9.34375 3.15625C9.53125 2.96875 9.875 2.96875 10.0625 3.15625L10.8438 3.9375C11.0312 4.125 11.0312 4.46875 10.8438 4.65625L7.46875 8Z",
    fill: "#CE0E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCrossIcon);
export default __webpack_public_path__ + "static/media/RedCrossIcon.d59ea278953701771ee9099c7bd60663.svg";
export { ForwardRef as ReactComponent };